export const SUCCESS_GET_ALL_ROUTING_RULES = 'SUCCESS_GET_ALL_ROUTING_RULES';
export const FAILED_GET_ALL_ROUTING_RULES = 'FAILED_GET_ALL_ROUTING_RULES';
export const SUCCESS_GET_ROUTING_RULE = 'SUCCESS_GET_ROUTING_RULE';
export const FAILED_GET_ROUTING_RULE = 'FAILED_GET_ROUTING_RULE';
export const SUCCESS_CREATE_ROUTING_RULE = 'SUCCESS_CREATE_ROUTING_RULE';
export const FAILED_CREATE_ROUTING_RULE = 'FAILED_CREATE_ROUTING_RULE';
export const SUCCESS_UPDATE_ROUTING_RULE = 'SUCCESS_UPDATE_ROUTING_RULE';
export const FAILED_UPDATE_ROUTING_RULE = 'FAILED_UPDATE_ROUTING_RULE';
export const SUCCESS_DELETE_ROUTING_RULE = 'SUCCESS_DELETE_ROUTING_RULE';
export const FAILED_DELETE_ROUTING_RULE = 'FAILED_DELETE_ROUTING_RULE';



// WEBPACK FOOTER //
// src/state/constants/routingRuleConstants.js